module.exports = __webpack_public_path__ + "img/404.84e2d675.webp";